import { registerPlugin } from "@capacitor/core";
const SegmentCapacitorSDK = registerPlugin("SegmentCapacitorPlugin", {
    web: () => import("./web").then((m) => new m.SegmentCapacitorPluginWeb()),
});
export * from "./definitions";
export { SegmentCapacitorSDK as SegmentCapacitorPlugin };
//# sourceMappingURL=index.js.map